
import { Injectable } from '@angular/core';

import { ActionHandler } from '@app/core/components/actions/action.handler';

@Injectable()
export class MasterMasterGroupsActions {
    constructor(
        private actionHandler: ActionHandler,
        
    ) {}



}